export default __webpack_public_path__ + "static/media/SWT0020.34I-21324_-15286_0.13fdd96c.jpg";